import React, { useState, useEffect } from 'react';
import { Progress, Modal } from 'antd';
const ProcessModal = ({ t, visible, handleClose }) => {
  const [progress, setProgress] = useState(0);
  let interval = undefined;
  useEffect(() => {
    if (visible) {
      interval = window.setInterval(() => {
        setProgress(current => (current < 90 ? current + 5 : 99));
      }, 150);
    } else {
      clearInterval(interval);
      setProgress(0);
    }
  }, [visible]);
  return (
    <Modal
      centered
      visible={visible}
      width={572}
      title={t('cms.properties_bulk_operation.modal.title.processing')}
      onCancel={handleClose}
      footer={null}
    >
      <Progress percent={progress} status="active" />
    </Modal>
  );
};

export default ProcessModal;
